import { render } from "./ExpressConfig.vue?vue&type=template&id=1739103b"
import script from "./ExpressConfig.vue?vue&type=script&lang=js"
export * from "./ExpressConfig.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__